"use client";

import Icon from "@afa-shared/afa-components/dist/Icon";
import AfaBreadCrumbs from "@components/AfaBreadcrumbs";
import CFContentArea from "@components/cFContentArea";
import Grid from "@components/client/Grid";
import LeftMenu from "@components/navigation/LeftMenu";
import { getTopBreadCrumbLinks } from "@containers/InsuranceHandbookSearchPage/utils/sok-i-handbokenHelper";
import { defaultContext } from "@utils/contextHelper/getInitialContext";
import clsx from "clsx";
import { ReactNode, useId, useRef, useState } from "react";

import { useEscape } from "hooks/useEscape";
import useMediaQuery from "hooks/useMediaQuery";

import insuranceSearchStyles from "../InsuranceSearch.module.css";

interface IInsuranceSearchContentWrapper {
  leftMenuItems: any;
  children: ReactNode;
  inheritedContentArea?: any;
}

const InsuranceSearchContentWrapper = ({
  inheritedContentArea,
  leftMenuItems,
  children,
}: IInsuranceSearchContentWrapper) => {
  const [openLeftMenu, setOpenLeftMenu] = useState<boolean>(false);
  const isTablet = useMediaQuery("tablet");
  const isDesktopUp = useMediaQuery("desktopup");
  const mobileButtonRef = useRef(null);
  const labelId = useId();
  const context = defaultContext;

  useEscape(
    mobileButtonRef,
    () => {
      mobileButtonRef?.current?.focus();
      setOpenLeftMenu(false);
    },
    openLeftMenu,
  );

  return (
    <div className={insuranceSearchStyles.insuranceSearchPage}>
      {/* Togglebutton menu for tablet and mobile */}
      {isTablet && (
        <div className={insuranceSearchStyles.toggleButtonWrapper}>
          <button
            className={insuranceSearchStyles.toggleButton}
            onClick={() => {
              setOpenLeftMenu(!openLeftMenu);
            }}
            ref={mobileButtonRef}
            aria-labelledby={labelId}
            aria-expanded={openLeftMenu}
          >
            <div>
              <Icon name={"page_menu"} size="sm" className={insuranceSearchStyles.iconList} />
              <span id={labelId}>
                {openLeftMenu
                  ? "Stäng menyn för Försäkringshandboken"
                  : "Välj sida i Försäkringshandboken"}
              </span>
            </div>
            <Icon
              name={openLeftMenu ? "close" : "chevron_down"}
              size="sm"
              className={insuranceSearchStyles.iconChevron}
            />
          </button>
        </div>
      )}

      {(isDesktopUp || !openLeftMenu) && (
        <AfaBreadCrumbs breadCrumbLinks={getTopBreadCrumbLinks()} ariaLabel={"Brödsmulor"} />
      )}

      <div
        className={clsx(
          insuranceSearchStyles.contentWrapper,
          openLeftMenu && insuranceSearchStyles.menuOpen,
        )}
      >
        <div
          className={clsx(
            insuranceSearchStyles.wrapper,
            openLeftMenu && insuranceSearchStyles.menuOpen,
          )}
        >
          <Grid
            mobile={12}
            desktop={4}
            desktopLarge={3}
            className={clsx(
              insuranceSearchStyles.menuGrid,
              openLeftMenu && insuranceSearchStyles.menuOpen,
            )}
          >
            <LeftMenu leftmenuItems={leftMenuItems} />
          </Grid>
          <Grid
            mobile={12}
            desktop={8}
            desktopLarge={6}
            className={clsx(
              insuranceSearchStyles.pageContent,
              openLeftMenu && insuranceSearchStyles.menuOpen,
            )}
            id={"innehall"}
          >
            {children}
          </Grid>
          {inheritedContentArea?.items?.length > 0 && (
            <Grid>
              <CFContentArea
                desktopColumns={1}
                contentAreaItems={inheritedContentArea?.items}
                heading={"h2"}
                context={context}
              />
            </Grid>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsuranceSearchContentWrapper;
